export const IMAGE_BOX_SIZE = '300px';
export const IMAGES_PER_PAGE = 24;
export const SCROLL_THRESHOLD = 350;
